import { InteractionType } from "@edgetier/watchtower-types";

/** Props for the SidebarItemWrapper component */
export interface ISidebarItemWrapperProps {
    children: React.ReactNode;
    onClick?: () => void;
    active?: boolean;
    "data-testid"?: string;
}

/** Props for the sidebar Item component representing an interaction entry */
export interface ISidebarItemProps {
    interactionType: InteractionType;
    dateTime: Date;
    onClick?: () => void;
    active?: boolean;
}
/** Props for the FetchMoreItems pagination control */
export interface ISidebarFetchMoreItemsProps {
    onClick?: () => void;
    label: string;
    type: SidebarItemType;
    isLoading?: boolean;
}

/** Enum distinguishing between older and newer pagination direction */
export enum SidebarItemType {
    Older = "older",
    Newer = "newer",
}
